/* Product card quick-add ("View options")
   - The form overlays the card image on all breakpoints. */

class ProductCardQuickAdd {
  static instances = [];

  constructor(card) {
    this.card = card;
    this.form = card.querySelector("[data-atc-form]");
    this.trigger = card.querySelector("[data-card-atc]");

    if (!this.form || !this.trigger) return;

    // Guard with a JS property (not a data-attribute) so Swiper's loop
    // clones — which copy attributes but not properties or listeners —
    // are treated as unbound and get wired up on re-init.
    if (card.__quickAddBound) return;
    card.__quickAddBound = true;

    this.homeParent = this.form.parentNode;
    this.homeNext = this.form.nextSibling;

    ProductCardQuickAdd.instances.push(this);
    this.bind();
  }

  static closeAll() {
    ProductCardQuickAdd.instances.forEach((i) => i.close());
  }

  // Bind any not-yet-bound product cards within a context. Safe to call
  // repeatedly (e.g. after async-loaded recommendations render).
  static initWithin(context = document) {
    context
      .querySelectorAll("[data-pcard]")
      .forEach((card) => new ProductCardQuickAdd(card));
  }

  get isOpen() {
    return this.form.classList.contains("is-open");
  }

  open() {
    ProductCardQuickAdd.closeAll();
    this.form.classList.add("is-open");
    this.card.classList.add("atc-open");
  }

  close() {
    if (!this.isOpen) return;

    this.form.classList.remove("is-open");
    this.card.classList.remove("atc-open");
  }

  bind() {
    this.trigger.addEventListener("click", (e) => {
      e.preventDefault();
      e.stopPropagation();
      this.isOpen ? this.close() : this.open();
    });

    this.form
      .querySelector(".product-card__atc-form-close-btn")
      ?.addEventListener("click", () => this.close());

    // Quantity stepper
    const qtyInput = this.form.querySelector(".product-card__quantity-input");
    this.form
      .querySelector("[data-qty-minus]")
      ?.addEventListener("click", () => {
        qtyInput.value = Math.max(1, parseInt(qtyInput.value || 1) - 1);
      });
    this.form
      .querySelector("[data-qty-plus]")
      ?.addEventListener("click", () => {
        qtyInput.value = parseInt(qtyInput.value || 1) + 1;
      });

    // Variant + purchase type -> price
    this.variantSelect = this.form.querySelector("[data-variant-select]");
    this.typeSelect = this.form.querySelector("[data-purchase-type-select]");
    this.subContainer = this.form.querySelector("[data-subscription-select]");
    this.subSelect = this.subContainer?.querySelector("select");
    this.priceDisplay = this.form.querySelector("[data-price-display]");

    const initialText = this.priceDisplay?.textContent.trim() || "$0";
    this.currencyPrefix = (initialText.match(/^[^\d]*/) || ["$"])[0];

    this.variantSelect?.addEventListener("change", () => this.updatePrice());
    this.typeSelect?.addEventListener("change", () => {
      const isSub = this.typeSelect.value === "subscription";
      if (this.subContainer) {
        this.subContainer.hidden = !isSub;
        if (this.subSelect) this.subSelect.disabled = !isSub;
      }
      this.updatePrice();
    });
  }

  updatePrice() {
    if (!this.priceDisplay) return;

    let price = parseInt(this.priceDisplay.dataset.price || 0);
    let subPrice = parseInt(this.priceDisplay.dataset.subPrice || 0);

    if (this.variantSelect) {
      const opt = this.variantSelect.selectedOptions[0];
      if (opt) {
        price = parseInt(opt.dataset.price || price);
        subPrice = parseInt(opt.dataset.subPrice || 0);
      }
    }

    const useSub =
      this.typeSelect &&
      this.typeSelect.value === "subscription" &&
      subPrice > 0;

    this.priceDisplay.textContent = this.formatMoney(useSub ? subPrice : price);
  }

  formatMoney(cents) {
    const value = (cents / 100).toFixed(2).replace(/\.00$/, "");
    return `${this.currencyPrefix}${value}`;
  }
}

// Expose so other scripts (e.g. async-loaded recommendations) can re-init
window.ProductCardQuickAdd = ProductCardQuickAdd;

document.addEventListener("DOMContentLoaded", () => {
  ProductCardQuickAdd.initWithin(document);

  // Close on outside click / Escape
  document.addEventListener("click", (e) => {
    if (
      e.target.closest("[data-atc-form]") ||
      e.target.closest("[data-card-atc]")
    )
      return;
    ProductCardQuickAdd.closeAll();
  });

  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape") ProductCardQuickAdd.closeAll();
  });

  // Close the quick-add once an item is successfully added
  // (the theme's existing subscriber in main.js opens the cart drawer)
  if (window.liquidAjaxCart?.subscribeToCartAjaxRequests) {
    liquidAjaxCart.subscribeToCartAjaxRequests((state, subscribeToResult) => {
      if (state.requestType === "add") {
        subscribeToResult((state) => {
          if (state.responseData?.ok) ProductCardQuickAdd.closeAll();
        });
      }
    });
  }
});
